import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireContract } from '~/utils/guards';

/**
 * Layout route: all /enrichments/meta/** require an enrolled meta-ads contract.
 * Both LIVE and TRIAL_POC are allowed so a trial subsidiary can open and resume
 * its own in-progress Catalog Operations Meta batches (which route here); only a
 * missing/unenrolled contract is gated to Product Not Enrolled.
 */
export const Route = createFileRoute('/_authenticated/_tenant/enrichments/meta')({
  beforeLoad: requireContract('meta', ['LIVE', 'TRIAL_POC']),
  component: () => <Outlet />,
});
